import React from 'react'
import { Star } from 'iconsax-react'
import { useAppDispatch } from '@SonarCX/hooks/redux'

import CommonButton from '../CommonButton'

import { patchFavorites } from '@SonarCX/slices/favorites'
import { useAreYouSure } from '@SonarCX/providers/AreYouSureProvider'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'
import useTaskMultiEdit from '../hooks/useTaskMultiEdit'

const Favorite: React.FC = () => {
  const dispatch = useAppDispatch()

  const { setV2, setTitle, setReason, setSubtext, setAction } = useAreYouSure()
  const { user } = useEnvironment()
  const { selected, numTasks, suffix } = useTaskMultiEdit()

  const acceptAction = React.useCallback(() => {
    const toAdd: APIFavorite[] = selected.map(id => ({
      item_id: id,
      type: 'task'
    }))
    dispatch(patchFavorites(user?.id, toAdd))
  }, [selected, dispatch, user])

  const handleClick = React.useCallback(() => {
    setV2(true)
    setTitle(`Favorite task${suffix}`)
    setReason(`Are you sure you want to favorite ${numTasks} task${suffix}?`)
    setSubtext('')
    setAction(acceptAction)
  }, [
    suffix,
    numTasks,
    setV2,
    setTitle,
    setReason,
    setSubtext,
    setAction,
    acceptAction
  ])

  return (
    <CommonButton title='Favorite' Icon={Star} onClick={handleClick}>
      <div>Favorite</div>
    </CommonButton>
  )
}

export default Favorite
